<template>
  <div class="register-con">
    <div class="logo-con">
      <img class="logo" :src="checkQiNiuUrl('ant-wx/202208101113/yungan_logo.png?imageView2/2/w/120/format/png/q/75')" alt="">
      <div class="logo-text">云柑社区</div>
    </div>

    <div v-if="bandInviteCode">
      <van-form
          class="register-form"
          ref="form"
          label-align="left"
          label-width="120"
          @submit="wxRegister"
      >
        <van-field
            v-model="registerInviteCode"
            clearable
            maxLength="6"
            :disabled="codeDisabled"
            label="邀请码"
            label-width="60"
            placeholder="请输入邀请码（平台邀请码为 0608）"
            :rules="[
              {required: true, message: '必填'},
              {pattern: /(^[A-Za-z0-9]{4}$)|(^[A-Za-z0-9]{6}$)/, message: '邀请码必须为4/6位数字/字母' }
            ]"
        >
        </van-field>
        <div class="btn-con">
          <van-button class="btn" type="default"
                      round block native-type="submit">下一步</van-button>
        </div>
      </van-form>
    </div>


  </div>
</template>

<script>
import preventBack from 'vue-prevent-browser-back'
import { newUserLogin, } from '@/api/login' // getUserByUserInfo,
import { memberInviteTargetOpenId } from '@/api/org'
export default {
  mixins: [preventBack],// 该页面禁止后退
  components: {
  },
  data () {
    return {
      bandInviteCode: false,
      inviteUserInfo: this.session('inviteUserInfo') || {},
      registerInviteCode: this.session('inviteUserInfo').inviteCode || '',
      codeDisabled: false
    }
  },
  computed: {},
  watch:{},
  created(){
    this.$toast.loading({duration: 0, message: '加载中...'});
    console.log( 'page-query: ',  this.$route.query.code)
    console.log( 'h5RegisterOk: ',  this.session('h5RegisterOk'))
    console.log( 'this.session(user): ',  this.session('user'))

    if(this.$route.query.code){
      this.getWeChatInfo(this.$route.query.code);
    }else { // 无code
      this.getAuthor();
    }

    // this.bandInviteCode = true

  },

  methods:{
    //微信授权登录：
    getAuthor(){
      this.$toast.clear();
      let appId = 'wx986bde2ed526db07' // 云柑社区-公众号
      // let appId = 'wx73aabcc815153945' // 云柑组织-公众号
      let redirect_uri = window.location.href
      let STATE = this.registerInviteCode || 'STATE'
      let getCodeUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirect_uri)}&response_type=code&scope=snsapi_userinfo&state=${STATE}#wechat_redirect`;
      window.location.href = getCodeUrl
    },
    //获取微信用户信息
    getWeChatInfo(code){
      let req = {
        loginType: 'WECHAT',
        loginByWechat: {
          wxCode: code
        }
      }
      newUserLogin(req).then(res => {
        this.$toast.clear();
        console.log('newUserLogin', res)
        let data = res.data || {}
        if(res.code===200){
          if(data.phone){ // 是否有手机号码
            this.goDownload(data)
          }else {
            this.session('user',data);
            this.goBindPhone()
          }
        }else if(res.code===206){ // 新用户
          this.session('user',data);
          if(!this.inviteUserInfo.inviteCode) {
            this.bandInviteCode = true
          }else {
            this.goBindPhone()
          }
        }else if(res.code===300){ // code 失效
          this.$router.replace(this.local('beforeLoginUrl'))
        }else {
          this.$toast(res.message)
        }
      })

    },

    wxRegister(){
      this.$refs['form'].validate().then(()=>{
        let inviteUserInfo = {...this.session('inviteUserInfo'), ...{inviteCode: this.registerInviteCode}}
        this.session('inviteUserInfo', inviteUserInfo)
        this.goBindPhone()
      })
    },

    // 上报后台发送 APP 加入组织的通知
    memberInviteTargetOpenId(req){
      memberInviteTargetOpenId(req).then(res=>{
        console.log('memberInviteTargetOpenId----res-->>', res)
      })
    },

    // 前往绑定手机号页面
    goBindPhone(){
      this.$router.push({name: 'h5RegisterPhone'})
    },

    // 跳转至下载
    goDownload(data){
      if(this.inviteUserInfo.orgMemberInviteId){
        this.memberInviteTargetOpenId({orgMemberInviteId: this.inviteUserInfo.orgMemberInviteId, userOpenId: data.userOpenId})
      }
      this.session('user',data);
      this.session('userOpenId', data.userOpenId)
      this.session('token', data.token)
      this.session('h5RegisterOk', true)
      this.$router.push({name: 'h5RegisterDownload'})
    },

  }
}
</script>

<style scoped lang="less">
.register-con{
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-color: #fff3e6;
  //background: url("@{qnUrl}ant-wx/202208101113/wx_register_bg.png") no-repeat 0 0;
  //background-size: 100% 100%;
  color: #333;
  .logo-con{
    width: 100%;
    height: 160px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo{
      width: 60px;
      height: 60px;
    }
    .logo-text{
      text-align: center;
      font-size: 18px;
      line-height: 35px;
      color: #444;
    }
    &.user-con{
      .img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 6px;
      }
      .nickname{
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        color: #000;
      }
      .text{
        text-align: center;
        font-size: 14px;
        color: #555;
      }
    }
  }

  .register-form{
    width: 355px;
    padding: 20px 0 0;
    margin: 60px auto 0;
    border-radius: 14px;
    /deep/ .van-cell{
      background: transparent;
    }
    /deep/ .van-cell::after{
      border-color: #a4a4a4;
    }
    .btn-con{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
      .btn{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        margin-bottom: 20px;
        color: #fff;
        width: 315px;
        height: 50px;
        border-radius: 25px;
        border: 2px solid #68d300;
        background-color: #68d300;
      }
    }
  }
}
</style>
